<template>
  <div class="time-counter">
    <button class="time-counter__minus" @click="decrease">
      <img src="@/assets/icons/minus.svg" alt="minus" />
    </button>
    <input
      v-model="counter"
      type="number"
      class="time-counter__counter-input"
      min="1"
      max="9999"
      @input="updateCounter"
    />
    <button class="time-counter__plus" @click="increase">
      <img src="@/assets/icons/plus.svg" alt="plus" />
    </button>
  </div>
</template>

<script setup>
import { usePowerCalcStore } from "~/store/powerCalcStore";

const powerCalcStore = usePowerCalcStore();

const props = defineProps({
  itemData: { type: Object, required: true },
});

const MAX_VALUE = 9999;

const counter = ref(props.itemData.timeValue);

const updateCounter = (event) => {
  const value = parseInt(event.target.value, 10);

  if (isNaN(value) || value <= 0) {
    value = 1;
  }

  if (value > MAX_VALUE) {
    value = MAX_VALUE;
  }

  counter.value = value;
  powerCalcStore.updateItemProperty(
    props.itemData.index,
    "timeValue",
    counter.value,
  );
};

const increase = () => {
  const step = props.itemData.timeUnit === "minutes" ? 5 : 1;
  if (counter.value + step <= MAX_VALUE) {
    counter.value += step;
    powerCalcStore.updateItemProperty(
      props.itemData.index,
      "timeValue",
      counter.value,
    );
  }
};

const decrease = () => {
  const step = props.itemData.timeUnit === "minutes" ? 5 : 1;
  if (counter.value === 1 && props.itemData.timeUnit === "hours") {
    powerCalcStore.updateTimeUnit(props.itemData.index, "minutes");
    counter.value = 60;
    powerCalcStore.updateItemProperty(
      props.itemData.index,
      "timeValue",
      counter.value,
    );
  } else if (counter.value - step >= 1) {
    counter.value -= step;
    powerCalcStore.updateItemProperty(
      props.itemData.index,
      "timeValue",
      counter.value,
    );
  }
};

watch(
  () => props.itemData.timeValue,
  (newValue) => {
    counter.value = newValue;
  },
);
</script>

<style lang="scss" scoped>
.time-counter {
  width: max-content;

  @include flex-container(row, space-between, center);

  border: 1px solid #e3e5e5;
  border-radius: 60px;

  padding: 8px 12px;
  gap: 8px;

  @include bigMobile() {
    padding: 8px;
  }

  &__counter-input {
    max-width: 48px;
    width: 100%;

    @include font(18, 24, 700);
    color: var(--color-ink-lighter);
    text-align: center;

    @include bigMobile() {
      max-width: 32px;

      @include font(14, 16, 700);
    }

    &[type="number"]::-webkit-outer-spin-button,
    &[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type="number"] {
      -moz-appearance: textfield;
    }
  }

  &__plus,
  &__minus {
    width: 24px;
    flex: 0 0 auto;

    @include bigMobile() {
      width: 18px;
    }
  }
}
</style>
